<template>
    <div class="components-container">
        <div class="titles">
            <span class="fonts">教学活动时间安排表（单位：周）</span>
        </div>
        <el-table :data="arrangeMent" ref="arrangementTable" class="tb-edit"
            border
            fit
            highlight-current-row
            element-loading-text="信息加载中"
            show-summary
            :header-cell-style="{ 'text-align': 'center' }"
            :row-style="{height: '53px'}"
            @row-click="(row, column, event) => handleRowClick('arrangementTable', row, column, event)"
            style="width:100%;">
            <el-table-column label="学期" prop="name" align="center">
            </el-table-column>
            <el-table-column label="入学教育" prop="jjRxjy" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model.number="scope.row.jjRxjy" class="numbers" controls-position="right"
                           :min="0.0" :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjRxjy) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="社会实践" prop="jjShsj" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjShsj" class="numbers" controls-position="right"
                          :min="0.0" :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjShsj) }}</span>
                </template>
            </el-table-column>
             <el-table-column label="军训" prop="jjJx" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjJx" class="numbers" controls-position="right"
                          :min="0.0" :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjJx) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="课堂教学" prop="jjKtjx" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjKtjx"  class="numbers" controls-position="right"
                          :min="0.0" :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjKtjx) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="实训（实验）" prop="jjSxsy" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjSxsy" class="numbers" controls-position="right"
                         :min="0.0"   :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjSxsy) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="实习" prop="jjSx" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjSx" class="numbers" controls-position="right"
                         :min="0.0"  :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"</el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjSx) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="考试" prop="jjKs" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjKs" class="numbers" controls-position="right"
                          :min="0.0" :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjKs) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="机动" prop="jjJd" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjJd" class="numbers" controls-position="right"
                         :min="0.0"   :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjJd) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="假期" prop="jjJq" align="center">
                <template slot-scope="scope">
                    <span class="el-edit">
                        <el-input-number v-model="scope.row.jjJq" class="numbers" controls-position="right"
                          :min="0.0"  :precision="1" :step="0.1" :max="1000" size="mini" :step-strictly="true"></el-input-number>
                    </span>
                    <span>{{ formatterNumShow(scope.row.jjJq) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="总计" prop="jjZj" align="center">
                <template slot-scope="scope">
                    <span>{{ computeAll(scope.row) }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props: ["editDisableState"],
        data() {
            return {
                arrangeMent: [{
                        name: "一",
                        jjXqxh: 1,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJx:0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "二",
                        jjXqxh: 2,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJx:0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "三",
                        jjXqxh: 3,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJx:0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "四",
                        jjXqxh: 4,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJx:0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "五",
                        jjXqxh: 5,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJq: 0,
                        jjJx:0,
                        jjZj: 0,
                    },
                    {
                        name: "六",
                        jjXqxh: 6,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjJx:0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "七",
                        jjXqxh: 7,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjJx:0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "八",
                        jjXqxh: 8,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjJx:0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "九",
                        jjXqxh: 9,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjJx:0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                    {
                        name: "十",
                        jjXqxh: 10,
                        jjRxjy: 0,
                        jjShsj: 0,
                        jjKtjx: 18,
                        jjSxsy: 0,
                        jjJx:0,
                        jjSx: 0,
                        jjKs: 0,
                        jjJd: 0,
                        jjJq: 0,
                        jjZj: 0,
                    },
                ],
                target: "",
                isUndefined: false,
            };
        },
        mounted() {},
        methods: {
            computeAll(row) {
                if (row.jjShsj == undefined) row.jjShsj = 0;
                if (row.jjKtjx == undefined) row.jjKtjx = 0;
                if (row.jjSxsy == undefined) row.jjSxsy = 0;
                if (row.jjSx == undefined) row.jjSx = 0;
                if (row.jjKs == undefined) row.jjKs = 0;
                if (row.jjJd == undefined) row.jjJd = 0;
                if (row.jjJq == undefined) row.jjJq = 0;
                if (row.jjJx == undefined) row.jjJx = 0;
                let all =
                    parseInt(row.jjRxjy) +
                    parseInt(row.jjShsj) +
                    parseInt(row.jjKtjx) +
                    parseInt(row.jjSxsy) +
                    parseInt(row.jjSx) +
                    parseInt(row.jjJx) +
                    parseInt(row.jjKs) +
                    parseInt(row.jjJd) +
                    parseInt(row.jjJq);
                row.jjZj = all;
                return row.jjZj;
            },
            formatterNumShow(str){
                if(str == '0.0')
                    str = '';

                return str;
            },
            handleRowClick(refName, row, column, event) {
                //不可编辑处理
                if(this.editDisableState){
                    this.$refs.arrangementTable.setCurrentRow();
                }
                this.$emit("changeEditRow", refName);
            },
        },
    };
</script>

<style scoped>
    .numbers {
        width: 80%;
    }

    .summary{
        font-weight: bold;
    }

    .tb-edit .el-edit {
        display: none;
    }

    .tb-edit .current-row .el-edit {
        display: block;
    }

    .tb-edit .current-row .el-edit+span {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// teachingArrangement.vue?9fc1ba80